import { TrackingPageLoader } from 'tracking-fe/src';

export const Loading = () => {
  return (
    <div className="flex justify-center items-center h-screen w-full">
      <TrackingPageLoader />
    </div>
  );
};
